import { useQueryClient } from '@tanstack/react-query';

import type { V2SessionResponse } from '../@types/uccSchema';
import { API_ENDPOINT } from '../@types/uccSchema';
import { MIXPANEL_TOKEN } from '../appConfig';
import type { EventNames, EventPropsMap } from '../constants/gtmEventNames';

export function useTrackEvent() {
  const queryClient = useQueryClient();

  const getUserProperty = () => {
    const response = queryClient.getQueryData<V2SessionResponse>([API_ENDPOINT.V2_SESSION]);

    if (!response?.data) {
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        role_b2b: false,
        role_b2c: false,
        role_admin: false,
        role_instructor: false,
      };
    }

    const { userId, role, userName, userEmail } = response.data;

    return {
      user_id: userId,
      user_name: userName,
      user_email: userEmail,
      role_b2b: role.isB2b,
      role_b2c: !role.isB2b,
      role_admin: role.isAdmin,
      role_instructor: role.isInstructor,
    };
  };

  function trackEvent(
    eventName: EventNames,
    props?: EventPropsMap[EventNames] extends undefined ? never : Partial<EventPropsMap[EventNames]>
  ) {
    if (!window.dataLayer) {
      console.log('[LOG] dataLayer is not defined');
    }

    return window.dataLayer.push({
      event: eventName,
      mixpanelToken: MIXPANEL_TOKEN,
      userId: getUserProperty().user_id,
      mxp___user: getUserProperty(),
      ...props,
    });
  }

  return { trackEvent };
}
